import React from 'react';
import { FaClock, FaUser } from 'react-icons/fa';

const RotaTodayAssignments = () => {  
  const todays_assignment = [
    {
       title : "Opening Check",
       time : "07:00",
       name : "Ali Hassan",
       name_code : "AH",
       bgColor: "bg-blue-50 text-blue-600 border-blue-100"
    },
    {
       title : "Closing Check",
       time : "19:00", // Adjusted for realistic PM shift context
       name : "Ali Hassan",
       name_code : "AH",
       bgColor: "bg-green-50 text-green-600 border-green-100"
    },
    {
       title : "Food Temperature Log",
       time : "12:30", // Adjusted for realistic Midday shift context
       name : "Ali Hassan",
       name_code : "AH",
       bgColor: "bg-purple-50 text-purple-600 border-purple-100"
    },
    {
       title : "Pat Inspection",
       time : "15:00", // Adjusted for realistic Afternoon shift context
       name : "Ali Hassan",
       name_code : "AH",
       bgColor: "bg-amber-50 text-amber-600 border-amber-100"
    },
  ];

  return (
    <section className="mt-8 p-5 bg-white border border-slate-100 rounded-2xl shadow-sm">
      <div className="mb-5 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-800">Today's Assignments</h2>
          <p className="text-xs text-slate-400 mt-0.5">Assigned staff members and shift schedule</p>
        </div>
        <span className="text-xs font-semibold px-2.5 py-1 bg-slate-100 text-slate-600 rounded-md">
          {todays_assignment.length} Shifts Today
        </span>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {todays_assignment.map((item, index) => (
          <div 
            key={index}
            className="flex items-center justify-between p-4 bg-white border border-slate-100 rounded-xl hover:border-slate-200 hover:shadow-sm transition-all duration-200"
          >
            {/* Left Section: Time and Title */}
            <div className="flex items-center gap-4">
              <div className="flex flex-col items-center justify-center border-r border-slate-100 pr-4 min-w-[60px]">
                <div className="flex items-center gap-1 text-slate-400 mb-0.5">
                  <FaClock className="w-3 h-3" />
                </div>
                <span className="text-sm font-bold text-slate-700">{item.time}</span>
              </div>
              
              <div>
                <h3 className="font-semibold text-slate-800 text-sm md:text-base">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1.5 mt-1 text-xs text-slate-500">
                  <FaUser className="w-2.5 h-2.5 text-slate-400" />
                  <span>{item.name}</span>
                </div>
              </div>
            </div>

            {/* Right Section: Avatar Circle Badge */}
            <div className={`w-10 h-10 rounded-full border ${item.bgColor} flex items-center justify-center font-bold text-xs tracking-wider shadow-inner`}>
              {item.name_code}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RotaTodayAssignments;
